
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.746 19.773l1.537-9.537h2.458l-1.537 9.537h-2.458zm11.37-9.303c-.484-.19-1.25-.4-2.2-.4-2.43 0-4.14 1.295-4.155 3.148-.015 1.37 1.22 2.135 2.152 2.59.958.468 1.28.767 1.276 1.184-.007.64-.764.932-1.47.932-.985 0-1.507-.144-2.316-.5l-.316-.152-.343 2.134c.573.266 1.635.497 2.737.51 2.583 0 4.26-1.28 4.28-3.26.01-1.086-.646-1.91-2.064-2.59-.86-.442-1.386-.735-1.38-1.183 0-.396.445-.82 1.408-.82a4.31 4.31 0 011.84.366l.22.107.332-2.068v.002zm3.275 5.92l.978-2.666c-.015.026.202-.552.326-.91l.166.823.57 2.75h-2.04v.003zm3.03-6.146h-1.9c-.588 0-1.03.17-1.287.79l-3.65 8.74h2.582s.42-1.175.517-1.433l3.147.005c.072.333.297 1.43.297 1.43h2.28l-1.988-9.532h.002zm-19.737-.002L8.28 16.744l-.258-1.32c-.448-1.524-1.843-3.175-3.404-4.002l2.2 8.34H9.42l3.87-9.52h-2.605z","fill":"#ADADAD"}}),_c('path',{attrs:{"d":"M6.046 10.238H2.083l-.032.197c3.083.79 5.124 2.697 5.97 4.99l-.86-4.382c-.15-.605-.58-.784-1.115-.805z","fill":"#ADADAD"}}),_c('path',{attrs:{"d":"M-4 .5h42A3.5 3.5 0 0141.5 4v22a3.5 3.5 0 01-3.5 3.5H-4A3.5 3.5 0 01-7.5 26V4A3.5 3.5 0 01-4 .5z","stroke":"#fff"}})])
          )
        }
      }
    